module.exports = __webpack_public_path__ + "img/PublishImg.ab4cf3e0.svg";